import React from "react";
import { FormField, CardSection } from "../../Common/FormComponents";
import { TT_AREA_OPTION_GROUPS } from "../../../config/ttAreas";

const AREA_OPTIONS = [
  { value: "", label: "Select Area/Region" },
  ...TT_AREA_OPTION_GROUPS,
];

const PropertyAddressSection = ({ formData, handleInputChange }) => (
  <CardSection title="Address Information">
    <div style={{ display: "grid", gap: "0.75rem" }}>
      <FormField
        label="Street Address"
        name="street"
        value={formData.street}
        onChange={handleInputChange}
        required
        placeholder="Enter street address"
      />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "0.75rem" }}>
        <FormField
          label="City"
          name="city"
          value={formData.city}
          onChange={handleInputChange}
          required
          placeholder="Enter city"
        />
        <FormField
          label="Area/Region"
          name="parish"
          type="select"
          value={formData.parish}
          onChange={handleInputChange}
          required
          options={AREA_OPTIONS}
        />
        <FormField
          label="Zip Code"
          name="zipCode"
          value={formData.zipCode}
          onChange={handleInputChange}
          placeholder="Zip code"
          className="mb-0"
        />
      </div>
    </div>
  </CardSection>
);

export default PropertyAddressSection;
